import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewInvitationOutDto,
  EditInvitationOutDto,
  DeleteInvitationOutDto,
  GetOneInvitationOutDto,
  GetAllInvitationsOutDto,
} from '../types/invitation.dto'

export class ErrorInvitation extends Error { }

const path = '/invite'

class Invitation {
  public new(payload: NewInvitationOutDto) {
    console.log('Invitation new:', payload)
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idInvitation, ...rest }: EditInvitationOutDto) {
    return action
      .Put({
        url: `${path}/${idInvitation}`,
        body: rest,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllInvitationsOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idInvitation }: GetOneInvitationOutDto) {
    return action
      .Get({
        url: `${path}/${idInvitation}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idInvitation }: DeleteInvitationOutDto) {
    return action
      .Del({
        url: `${path}/${idInvitation}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const invitation = new Invitation()
export default invitation
